export default (that) => [
  {
    text: that.$l('INDEX.btn_view_details') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_tips_fin_confirm') || '财务确认',
    icon: 'el-icon-s-check',
    menuType: 'finConfirm',
    divided: true,
    allow: 'C',
    data: {},
    show: ({ materialAbnormalStatus, processingStatus, confirmStatus }) =>
      materialAbnormalStatus === 'Y' && processingStatus === 'Y' && confirmStatus != 'Y',
  },
]
